export default __webpack_public_path__ + "static/media/Skirmisher's Great Shield.ea3adf35.jpg";